<template>
	<div class="row">
		<div class="telemedicine-management pr-3">
			<div class="row pl-3">
				<div class="col-12">
					<div class="d-flex py-1 align-items-center">
						<img class="mr-2" src="https://img.icons8.com/windows/50/0C53FB/how-many-quest.png"/><span class="txt-pri page-title">Thuốc</span>
					</div>
				</div>
				<div class="col-sm-12">
					<div class="row justify-content-lg-between">
						<div class="col-12 col-lg-auto mb-1">
							<div class="d-flex">
							</div>
						</div>
						<div class="col-12 col-lg-auto mb-1">
							<div class="d-flex">
								<button class="btn bg-pri bd-pri text-white btn-icon-add-sm" @click="addMedicine()">Thêm thuốc</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card radius-10 pt-4 pl-4 pr-4 border-0">
				<div class="table-responsive">
					<table class="table table-vcenter table-mobile-md card-table table-scroll">
						<thead>
							<tr>
								<th>Tên thuốc</th>
                <th>Đơn vị</th>
								<th>Thời gian tạo</th>
                <th>Chức năng</th>
							</tr>
						</thead>
						<tbody v-if="medicines && medicines.count && medicines.data" style="min-height: 600px;">
							<tr v-for="medicine in medicines.data" :key="medicine.id">
								<td>{{medicine && medicine.name ? medicine.name : ''}}</td>
                <td>{{medicine && medicine.amount_unit ? medicine.amount_unit : ''}}</td>
								<td v-html="medicine && medicine.created_at ? formatWeekdayTime(medicine.created_at) : ''"></td>
                <td>
                  <button class="btn btn-outline-primary btn-sm" @click="onUpdate(medicine)">Chỉnh sửa</button>
                  <button class="btn btn-outline-danger btn-sm ml-2 d-none" @click="onDelete(medicine.id)">Xoá</button>
                </td>
							</tr>
						</tbody>
					</table>
					<Pagination v-show="medicines && medicines.count" v-if="medicines" :items="medicines" :current_page="current_page" @onRefresh="getMedicines"></Pagination>
				</div>
				<div v-if="medicines && !medicines.count && !loading" class="row">
					<div class="col-sm-4 offset-sm-4 pt-3 pb-5 text-center">
						<img src="../../../public/assets/images/not-found-search.png" class="img-responsive p-0" alt="">
						<p class="robo-16-400 text-black">{{search ? 'HODO không tìm thấy thẻ tag mà bạn tìm' : 'Chưa có thẻ tag nào!' }}</p>
					</div>
				</div>
			</div>
		</div>
    <ModelMedicine :medicine="medicine" @onSubmitUpdate="onSubmitUpdate" @onSubmit="onSubmit"></ModelMedicine>
	</div>
</template>
<script>
  import ModelMedicine from '../../components/Diseases/ModalMedicine.vue'
  import Pagination from '../../components/Pagination'
  export default {
    name: 'MedicineListing',
    components: {Pagination, ModelMedicine},
    data () {
      return {
        medicines: null,
        loading: false,
        params: {
          limit: 10,
          search: '',
          sort: 'created_at',
          sort_by: 'desc'
        },
        search: '',
        current_page: 0,
        page: 1,
        medicine: ''
      }
    },
    mounted () {
      this.page = this.$route.query.page ? this.$route.query.page : 1
      this.getMedicines()
    },
    watch: {
      '$route.query.type': {
        handler: function () {
          let self = this
          self.page = self.$route.query.page
          self.getMedicines()
        },
        deep: true
      }
    },
    methods: {
      async getMedicines () {
        try {
          let self = this
          self.current_page = parseInt(self.$route.query.page) || 1
          self.params = {
            limit: 15,
            search: self.search,
            sort: 'created_at',
            sort_by: 'desc',
            page: self.current_page
          }
          const result = await self.$rf.getRequest('AuthRequest').getMedicines(self.params)
          self.medicines = result.data
          self.current_page = result.data.current_page
        } catch (e) {
          console.log(e)
        } finally {

        }
      },
      formatWeekdayTime (date_time) {
        var split_time = window.moment(date_time).format('DD/MM/YYYY HH:mm ').split(' ')
        var str_time = split_time[1] + '<br><small class="robo-12-400 text-muted">' + split_time[0] + '</small>'
        return str_time
      },
      onModel (show) {
        window.$('#modal--medicine').modal(show ? 'show' : 'hide')
      },
      addMedicine () {
        let self = this
        self.medicine = ''
        self.onModel(true)
      },
      async onDelete (id) {
        let self = this
        try {
          var r = confirm('Bạn có xoá thuốc này không?')
          if (r) {
            await self.$rf.getRequest('AdminRequest').postMedicineDelete(id).then(res => {
              self.getMedicines()
            })
            self.$toast.clear()
            self.$toast.open({
              message: 'Xoá thuốc thành công',
              type: 'success'
            })
          }
        } catch (e) {
          // statements
          console.log(e)
        }
      },
      onUpdate (item) {
        let self = this
        self.medicine = item
        self.onModel(true)
      },
      async onSubmitUpdate (data) {
        let self = this
        try {
          await self.$rf.getRequest('AdminRequest').postMedicineId(data.id, data).then(res => {
            self.getMedicines()
            self.onModel(false)
          })
          self.$toast.clear()
          self.$toast.open({
            message: 'Chỉnh sửa thuốc thành công',
            type: 'success'
          })
        } catch (e) {
          // statements
          console.log(e)
        }
      },
      async onSubmit (data) {
        let self = this
        try {
          var dt = {
            medicines: []
          }
          dt.medicines.push(data)
          await self.$rf.getRequest('AdminRequest').postMedicines(dt).then(res => {
            self.getMedicines()
            self.onModel(false)
          })
          self.$toast.clear()
          self.$toast.open({
            message: 'Thêm thuốc thành công',
            type: 'success'
          })
        } catch (e) {
          // statements
          console.log(e)
        }
      }
    }
  }
</script>
<style scoped></style>